import { Integration_Service_Names_Enum } from '@main/graphql/types.admin.generated';

import { IntegrationService } from '../../../../lib';
import { ZendeskConnector } from '../../connector';

export const ZendeskService = IntegrationService.make({
  connector: ZendeskConnector,
  name: Integration_Service_Names_Enum.Zendesk,
});
